<div
	#NodeContainer
	id="node-container"
>
	<ng-container *ngIf="nodes?.length; else SelectionTemplate">
		<ng-container *ngFor="let node of nodes">
			<ng-container *ngTemplateOutlet="NodeTemplate; context: { node }" />
		</ng-container>
	</ng-container>
</div>
<ng-template
	#NodeTemplate
	let-node="node"
>
	<a
		class="node-item"
		tabindex="-1"
		[attr.data-id]="node.id"
		[attr.id]="'node-' + node.id"
		[class.active]="selectedNode === node"
		(focus)="onNodeSelect(node)"
	>
		<div class="ada-container ada-col-0 ada-flex-align-center">
			<button
				*ngIf="node.children?.length"
				[class.is-open]="node.isExpanded"
				[ngStyle]="{ 'margin-right': UI.Spacing.SPACING_SMALL }"
				(click)="node.toggle()"
			>
				<ada-icon
					[color]="'foreground'"
					[icon]="'faAngleRightOutline'"
				/>
			</button>
			<div
				*ngIf="!node.children?.length"
				[ngStyle]="{ 'margin-right': UI.Spacing.SPACING_SMALL, width: UI.Spacing.SPACING_LARGE }"
			></div>
			<span
				class="logical-icon"
				[ngStyle]="{ 'margin-right': UI.Spacing.SPACING_SMALL }"
			>
				<span
					*ngIf="node.filterType | isLogicType"
					[ngClass]="[node.children?.length ? 'expandable' : 'flat']"
				>
					{{ node.filterType | logicalIcon }}
				</span>
				<ada-icon
					*ngIf="!(node.filterType | isLogicType)"
					[color]="'foreground'"
					[icon]="node.filterType | logicalIcon"
				/>
			</span>
			<ada-text
				[content]="
					(node.filterType | isLogicType)
						? node.display
						: (node.userInput.value | adaPrerequisiteObjectId | adaGetServerObjectName: metadataClassName | async)
				"
			/>
			<ada-clickable
				class="filter-node-icon-target ada-container ada-flex-center"
				[adaMenuTrigger]="FilterMenu"
				[adaMenuTriggerData]="node"
			>
				<ada-icon
					#NodeMenuIcon
					ada-type="base"
					class="filter-node-icon-target ada-container ada-flex-center"
					color="primary"
					icon="faEllipsisH"
					tooltip="Filter Options"
					[id]="node.id"
				/>
			</ada-clickable>
		</div>
	</a>
	<div
		*ngIf="node.isExpanded && node.children?.length"
		class="node-children"
	>
		<ng-container *ngFor="let child of node.children">
			<ng-container *ngTemplateOutlet="NodeTemplate; context: { node: child }" />
		</ng-container>
	</div>
</ng-template>
<ng-template #SelectionTemplate>
	<div class="node-item">
		<div class="ada-container ada-col-0 ada-flex-align-center">
			<div [ngStyle]="{ 'margin-right': UI.Spacing.SPACING_SMALL, width: UI.Spacing.SPACING_LARGE }"></div>
			<span
				class="logical-icon"
				[ngStyle]="{ 'margin-right': UI.Spacing.SPACING_SMALL }"
			>
				<ada-icon
					[color]="'foreground'"
					[icon]="'faFilter'"
				/>
			</span>
			<ada-text
				[content]="'Select Operator or Condition'"
				[fontWeight]="'bold'"
			/>
			<ada-clickable
				class="filter-node-icon-target ada-container ada-flex-center"
				[adaMenuTrigger]="FilterMenu"
			>
				<ada-icon
					#NodeMenuIcon
					ada-type="base"
					class="filter-node-icon-target ada-container ada-flex-center"
					color="primary"
					icon="faEllipsisH"
					tooltip="Filter Options"
					[id]="0"
				/>
			</ada-clickable>
		</div>
	</div>
</ng-template>
<ada-menu
	#FilterMenu
	[controller]="filterMenuController"
	[isDisabled]="isDisabled"
/>
<ada-overlay
	#OperatingConditionOverlay
	[title]="(overlayEditing ? 'Editing ' : 'Creating ') + 'Operating Condition'"
	(sneakyClose)="cancelOverlay($event)"
	(submit)="submitOverlay()"
>
	<ada-container
		*adaTemplateMarker
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[colCount]="4"
		[padding]="UI.Spacing.SPACING_LARGE"
	>
		<ada-label
			content="Operating Condition"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-combo
			data-testid="prerequisite-tree-operating-condition-dropdown"
			[options]="filterTypeOptions"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			[value]="overlayFilterType"
			(valueChange)="setOverlayFilterType($event)"
		/>
		<ada-label
			content="Prerequisite"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-object-list
			data-testid="prerequisite-tree-overlay-product-list"
			[isMultiselect]="isMulti"
			[javaClassName]="metadataClassName"
			[objectIds]="overlayValue"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			[validators]="[validateProductSelection | adaBindMethod: this]"
			(objectIdsChange)="updateOverlayValue($event)"
		/>
	</ada-container>
</ada-overlay>
